/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogLoaded' event (evid: 1117)
 *
 * Event description: get feedback site selector dialog successfully loaded
 *
 * @param {getFeedbackSiteSelectorDialogLoadedParams} params - The parameters for this event
 * @property {string} feature_state - the state of the feature when the site selector loaded
 * @property {string} origin - origin
 * @return {LogObject<getFeedbackSiteSelectorDialogLoadedParams>} LogObject<getFeedbackSiteSelectorDialogLoadedParams>
 */
export function getFeedbackSiteSelectorDialogLoaded(params) {
    return { evid: 1117, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackOnOffFilterOnCommentList' event (evid: 1113)
 *
 * Event description: clicks on/off on filter in comment list at get feedback view-comments page
 *
 * @param {getFeedbackOnOffFilterOnCommentListParams} params - The parameters for this event
 * @property {string} desktop_filter_state - on/off
 * @property {string} mobile_filter_state - on/off
 * @property {GUID} msid - msid
 * @property {string} resolved_filter_state - on/off
 * @return {LogObject<getFeedbackOnOffFilterOnCommentListParams>} LogObject<getFeedbackOnOffFilterOnCommentListParams>
 */
export function getFeedbackOnOffFilterOnCommentList(params) {
    return { evid: 1113, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackAddACommentButton' event (evid: 1115)
 *
 * Event description: clicked on add a comment
 *
 * @param {getFeedbackAddACommentButtonParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {GUID} contactId - Contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackAddACommentButtonParams>} LogObject<getFeedbackAddACommentButtonParams>
 */
export function getFeedbackAddACommentButton(params) {
    return { evid: 1115, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackCopyLinkLinkCouldNotBeGenerated' event (evid: 1121)
 *
 * Event description: clicked on get feedback copy share link from 'origin' and the link could not be generated
 *
 * @param {getFeedbackCopyLinkLinkCouldNotBeGeneratedParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackCopyLinkLinkCouldNotBeGeneratedParams>} LogObject<getFeedbackCopyLinkLinkCouldNotBeGeneratedParams>
 */
export function getFeedbackCopyLinkLinkCouldNotBeGenerated(params) {
    return { evid: 1121, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackResolveComment' event (evid: 1109)
 *
 * Event description: Clicked to resolve to a comment
 *
 * @param {getFeedbackResolveCommentParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {string} commentStatus - comment_status
 * @property {string} editorVersion - editor/editorx
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @return {LogObject<getFeedbackResolveCommentParams>} LogObject<getFeedbackResolveCommentParams>
 */
export function getFeedbackResolveComment(params) {
    return { evid: 1109, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackEditCommentOrReply' event (evid: 1110)
 *
 * Event description: finish editing a comment or reply
 *
 * @param {getFeedbackEditCommentOrReplyParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {string} commentStatus - comment_status
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/commenter
 * @property {string} mode - desktop/mobile
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @property {string} page_id - homepage/other
 * @property {GUID} response_id - Response guid for each response
 * @property {number} response_number - Number of the response in comment
 * @property {string} text - text in comment/reply
 * @property {string} type - comment/reply
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackEditCommentOrReplyParams>} LogObject<getFeedbackEditCommentOrReplyParams>
 */
export function getFeedbackEditCommentOrReply(params) {
    return { evid: 1110, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackDeleteCommentOrResponse' event (evid: 1111)
 *
 * Event description: Click to delete comment or response
 *
 * @param {getFeedbackDeleteCommentOrResponseParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {string} commentStatus - comment_status
 * @property {GUID} contactId - ContactId (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/commenter
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @property {string} page_id - page_id
 * @property {GUID} response_id - Response guid for each response
 * @property {string} type - comment/reply
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackDeleteCommentOrResponseParams>} LogObject<getFeedbackDeleteCommentOrResponseParams>
 */
export function getFeedbackDeleteCommentOrResponse(params) {
    return { evid: 1111, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnHeader' event (evid: 1131)
 *
 * Event description: Fires when user (client or partner) clicks on header
 *
 * @param {getFeedbackClickOnHeaderParams} params - The parameters for this event
 * @property {string} clickType - click type
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/commenter
 * @property {GUID} msid - msid
 * @property {string} page_id - page_id
 * @return {LogObject<getFeedbackClickOnHeaderParams>} LogObject<getFeedbackClickOnHeaderParams>
 */
export function getFeedbackClickOnHeader(params) {
    return { evid: 1131, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackPartnerSideGenericClick' event (evid: 1137)
 *
 * Event description: generic click for the partner side get feedback feature
 *
 * @param {getFeedbackPartnerSideGenericClickParams} params - The parameters for this event
 * @property {string} click_type - what the user clicked on
 * @property {string} feature_state - the state of the feature - zero/no_sites/active
 * @property {GUID} msid_selected - msid related to the click if relevant
 * @property {string} origin - origin
 * @property {string} product - to which product/screen the click is related to
 * @return {LogObject<getFeedbackPartnerSideGenericClickParams>} LogObject<getFeedbackPartnerSideGenericClickParams>
 */
export function getFeedbackPartnerSideGenericClick(params) {
    return { evid: 1137, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnDropdownMenu' event (evid: 1125)
 *
 * Event description: Fires when user clicks on the dropdown menu to filter comments
 *
 * @param {getFeedbackClickOnDropdownMenuParams} params - The parameters for this event
 * @property {string} editorVersion - editor/edix
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackClickOnDropdownMenuParams>} LogObject<getFeedbackClickOnDropdownMenuParams>
 */
export function getFeedbackClickOnDropdownMenu(params) {
    return { evid: 1125, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackErrorMessage' event (evid: 1134)
 *
 * Event description: Fires when error in the get feedback link
 *
 * @param {getFeedbackErrorMessageParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackErrorMessageParams>} LogObject<getFeedbackErrorMessageParams>
 */
export function getFeedbackErrorMessage(params) {
    return { evid: 1134, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackHideOrShowCommentList' event (evid: 1112)
 *
 * Event description: clicked to hide/show comment list on get feedback view-comments page
 *
 * @param {getFeedbackHideOrShowCommentListParams} params - The parameters for this event
 * @property {string} action - Hide or show comments
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackHideOrShowCommentListParams>} LogObject<getFeedbackHideOrShowCommentListParams>
 */
export function getFeedbackHideOrShowCommentList(params) {
    return { evid: 1112, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnSend' event (evid: 1122)
 *
 * Event description: Fires when user sends get feedback notification
 *
 * @param {getFeedbackClickOnSendParams} params - The parameters for this event
 * @property {number} countInvitationsContacts - count invitations to contacts
 * @property {number} countInvitations - Count of invitations sent
 * @property {string} feature_state - the state of the feature when user clicks on send
 * @property {GUID} msid - msid
 * @property {string} note - notes of the share dialog
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackClickOnSendParams>} LogObject<getFeedbackClickOnSendParams>
 */
export function getFeedbackClickOnSend(params) {
    return { evid: 1122, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClicksBack' event (evid: 1124)
 *
 * Event description: FIres when user clicks back in the dialogue box
 *
 * @param {getFeedbackClicksBackParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackClicksBackParams>} LogObject<getFeedbackClicksBackParams>
 */
export function getFeedbackClicksBack(params) {
    return { evid: 1124, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackChooseMode' event (evid: 1128)
 *
 * Event description: Fires when user (client or partner) choose a mode
 *
 * @param {getFeedbackChooseModeParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} device - editorx device
 * @property {string} editorVersion - {editor/editorx]
 * @property {string} user_type - user_type
 * @property {string} mode - {Desktop/Mobile}
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackChooseModeParams>} LogObject<getFeedbackChooseModeParams>
 */
export function getFeedbackChooseMode(params) {
    return { evid: 1128, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackViewCommentsButton' event (evid: 1105)
 *
 * Event description: clicked on get feedback view comments from 'origin'
 *
 * @param {getFeedbackViewCommentsButtonParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/adi/standard
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackViewCommentsButtonParams>} LogObject<getFeedbackViewCommentsButtonParams>
 */
export function getFeedbackViewCommentsButton(params) {
    return { evid: 1105, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackViewComment' event (evid: 1107)
 *
 * Event description: Click to view the comment
 *
 * @param {getFeedbackViewCommentParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {string} commentStatus - comment_status
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/commenter
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackViewCommentParams>} LogObject<getFeedbackViewCommentParams>
 */
export function getFeedbackViewComment(params) {
    return { evid: 1107, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackViewCommentsPageLoaded' event (evid: 1106)
 *
 * Event description: View comments page loaded
 *
 * @param {getFeedbackViewCommentsPageLoadedParams} params - The parameters for this event
 * @property {string} breakpoint
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/contributor
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackViewCommentsPageLoadedParams>} LogObject<getFeedbackViewCommentsPageLoadedParams>
 */
export function getFeedbackViewCommentsPageLoaded(params) {
    return { evid: 1106, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackChoosePage' event (evid: 1130)
 *
 * Event description: Fires when user (client or partner) choose a page
 *
 * @param {getFeedbackChoosePageParams} params - The parameters for this event
 * @property {GUID} contactId - contact_id if any
 * @property {string} device - editorx device
 * @property {string} editorVersion - {editor/editorx]
 * @property {string} user_type - owner/contributor/commenter
 * @property {string} mode - {Desktop/Mobile/Tablet}
 * @property {GUID} msid - msid
 * @property {string} pageName - page name
 * @return {LogObject<getFeedbackChoosePageParams>} LogObject<getFeedbackChoosePageParams>
 */
export function getFeedbackChoosePage(params) {
    return { evid: 1130, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackDialogLoaded' event (evid: 1102)
 *
 * Event description: get feedback dialog successfully loaded
 *
 * @param {getFeedbackDialogLoadedParams} params - The parameters for this event
 * @property {string} editorVersion - standard/Editor/ADI/EditorX
 * @property {string} feature_state - the state of the feature when the dialog loaded
 * @property {GUID} msid - msid dialog belongs to
 * @property {string} origin - entry point name
 * @return {LogObject<getFeedbackDialogLoadedParams>} LogObject<getFeedbackDialogLoadedParams>
 */
export function getFeedbackDialogLoaded(params) {
    return { evid: 1102, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickEditReply' event (evid: 1133)
 *
 * Event description: Tracks click on edit site
 *
 * @param {getFeedbackClickEditReplyParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} click_type - click_type
 * @property {string} commentStatus - comment_status
 * @property {string} editorVersion - version
 * @property {string} user_type - user_type
 * @property {GUID} msid - msid
 * @property {GUID} visitorId - visitorid
 * @return {LogObject<getFeedbackClickEditReplyParams>} LogObject<getFeedbackClickEditReplyParams>
 */
export function getFeedbackClickEditReply(params) {
    return { evid: 1133, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackEditProfile' event (evid: 1127)
 *
 * Event description: Fires when user clicks on Edit Profile
 *
 * @param {getFeedbackEditProfileParams} params - The parameters for this event
 * @property {string} comment_id - {}
 * @property {string} mode - desktop/mobile
 * @property {GUID} msid - msid
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackEditProfileParams>} LogObject<getFeedbackEditProfileParams>
 */
export function getFeedbackEditProfile(params) {
    return { evid: 1127, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackDialogClosed' event (evid: 1103)
 *
 * Event description: clicked on close get feedback dialog
 *
 * @param {getFeedbackDialogClosedParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/standard/adi
 * @property {string} feature_state - the state of the feature when the modal was closed (if relevant)
 * @property {GUID} msid - msid
 * @property {string} origin - origin
 * @return {LogObject<getFeedbackDialogClosedParams>} LogObject<getFeedbackDialogClosedParams>
 */
export function getFeedbackDialogClosed(params) {
    return { evid: 1103, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackLightboxAction' event (evid: 1114)
 *
 * Event description: clicked on lightbox
 *
 * @param {getFeedbackLightboxActionParams} params - The parameters for this event
 * @property {string} action - got-it/close
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} light_box_guid - guid
 * @property {string} light_box_name - name
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @property {GUID} visitorId - visitors guid
 * @return {LogObject<getFeedbackLightboxActionParams>} LogObject<getFeedbackLightboxActionParams>
 */
export function getFeedbackLightboxAction(params) {
    return { evid: 1114, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickedCopyLink' event (evid: 1104)
 *
 * Event description: clicked on get feedback copy share link from 'origin'
 *
 * @param {getFeedbackClickedCopyLinkParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx/standard/adi
 * @property {string} feature_state - the state of the feature when user clicked copy
 * @property {string} user_type - owner/contributor
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackClickedCopyLinkParams>} LogObject<getFeedbackClickedCopyLinkParams>
 */
export function getFeedbackClickedCopyLink(params) {
    return { evid: 1104, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 1100)
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 1100, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogSearch' event (evid: 1119)
 *
 * Event description: search site in the site selector dialog
 *
 * @param {getFeedbackSiteSelectorDialogSearchParams} params - The parameters for this event
 * @property {string} text - text searched
 * @return {LogObject<getFeedbackSiteSelectorDialogSearchParams>} LogObject<getFeedbackSiteSelectorDialogSearchParams>
 */
export function getFeedbackSiteSelectorDialogSearch(params) {
    return { evid: 1119, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClickOnOptionDropdownMenu' event (evid: 1126)
 *
 * Event description: Fires when user clicks on an option from the  dropdown menu to filter comments
 *
 * @param {getFeedbackClickOnOptionDropdownMenuParams} params - The parameters for this event
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - commenter/owner/contributor
 * @property {GUID} msid - msid
 * @property {string} option - option chosen
 * @return {LogObject<getFeedbackClickOnOptionDropdownMenuParams>} LogObject<getFeedbackClickOnOptionDropdownMenuParams>
 */
export function getFeedbackClickOnOptionDropdownMenu(params) {
    return { evid: 1126, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackMoveAComment' event (evid: 1116)
 *
 * @param {getFeedbackMoveACommentParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - owner/commenter
 * @property {string} mode - desktop/mobile
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @property {string} page_id - homepage/other
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackMoveACommentParams>} LogObject<getFeedbackMoveACommentParams>
 */
export function getFeedbackMoveAComment(params) {
    return { evid: 1116, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackDailogEntryPoint' event (evid: 1101)
 *
 * Event description: All entry points to the get feedback dialog screen
 *
 * @param {getFeedbackDailogEntryPointParams} params - The parameters for this event
 * @property {GUID} msid - What msid did they click on
 * @property {string} origin - entry point name
 * @return {LogObject<getFeedbackDailogEntryPointParams>} LogObject<getFeedbackDailogEntryPointParams>
 */
export function getFeedbackDailogEntryPoint(params) {
    return { evid: 1101, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorClick' event (evid: 1132)
 *
 * Event description: Tracks click on the site selector.
 *
 * @param {getFeedbackSiteSelectorClickParams} params - The parameters for this event
 * @property {string} click_type - click_type
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackSiteSelectorClickParams>} LogObject<getFeedbackSiteSelectorClickParams>
 */
export function getFeedbackSiteSelectorClick(params) {
    return { evid: 1132, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackAddCommentOrReply' event (evid: 1108)
 *
 * Event description: finish adding comment or reply
 *
 * @param {getFeedbackAddCommentOrReplyParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} comment_id - {}
 * @property {string} commentStatus - comment_status
 * @property {GUID} contactId - ContactId (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {boolean} emailInput - user input email?
 * @property {string} user_type - owner/commenter
 * @property {string} mode - desktop/mobile
 * @property {GUID} msid - msid
 * @property {string} origin - page name
 * @property {string} page_id - homepage/other
 * @property {GUID} response_id - Response guid for each response
 * @property {number} response_number - Number of the response in comment
 * @property {string} text - text in comment/reply
 * @property {string} type - comment/reply
 * @property {GUID} visitorId - {}
 * @return {LogObject<getFeedbackAddCommentOrReplyParams>} LogObject<getFeedbackAddCommentOrReplyParams>
 */
export function getFeedbackAddCommentOrReply(params) {
    return { evid: 1108, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackGenericClick' event (evid: 1135)
 *
 * Event description: Generic click event for the get feedback feature
 *
 * @param {getFeedbackGenericClickParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {string} click_type - describes the object that has been clicked
 * @property {boolean} comment_has_email - whether the client put his email
 * @property {GUID} comment_id - identifier for the specific comment
 * @property {GUID} contact_id - contact id (if any)
 * @property {string} editor_version - editor/editorx/studio
 * @property {string} feedback_user_type - owner/client
 * @property {GUID} msid - msid
 * @property {string} page_id - page identifier
 * @property {string} response_id - identifier for the specific response
 * @property {string} text - text in comment/reply
 * @return {LogObject<getFeedbackGenericClickParams>} LogObject<getFeedbackGenericClickParams>
 */
export function getFeedbackGenericClick(params) {
    return { evid: 1135, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackPartnerSidePageLoaded' event (evid: 1138)
 *
 * Event description: this event fires when specific pages / modals are loaded
 *
 * @param {getFeedbackPartnerSidePageLoadedParams} params - The parameters for this event
 * @property {string} feature_state - the state of the feature - zero/no_sites/active
 * @property {GUID} msid_selected - msid related to the click if relevant
 * @property {string} origin - origin
 * @property {string} product - to which product/screen the click is related to
 * @return {LogObject<getFeedbackPartnerSidePageLoadedParams>} LogObject<getFeedbackPartnerSidePageLoadedParams>
 */
export function getFeedbackPartnerSidePageLoaded(params) {
    return { evid: 1138, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackClientSidePageLoaded' event (evid: 1120)
 *
 * Event description: Client-side / leave comments page loaded
 *
 * @param {getFeedbackClientSidePageLoadedParams} params - The parameters for this event
 * @property {GUID} contactId - contact_id (if any)
 * @property {string} editorVersion - editor/editorx
 * @property {string} user_type - commenter/owner
 * @property {GUID} visitor_id - guid
 * @return {LogObject<getFeedbackClientSidePageLoadedParams>} LogObject<getFeedbackClientSidePageLoadedParams>
 */
export function getFeedbackClientSidePageLoaded(params) {
    return { evid: 1120, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackPageLoaded' event (evid: 1136)
 *
 * Event description: Generic load event for the get feedback feature.
 * fires when a page is loaded.
 *
 * @param {getFeedbackPageLoadedParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {GUID} contact_id - contact id (if any)
 * @property {string} editor_version - 'editor'/'editorx'/'studio'
 * @property {string} feedback_user_type - owner/client
 * @property {string} page_id - page identifier
 * @return {LogObject<getFeedbackPageLoadedParams>} LogObject<getFeedbackPageLoadedParams>
 */
export function getFeedbackPageLoaded(params) {
    return { evid: 1136, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackChangePixelsHeader' event (evid: 1129)
 *
 * Event description: Fires when user (client or partner) changes pixels
 *
 * @param {getFeedbackChangePixelsHeaderParams} params - The parameters for this event
 * @property {string} breakpoint - breakpoint
 * @property {GUID} contactId - contact_id if any
 * @property {string} device - editorx device
 * @property {string} editorVersion - {editor/editorx]
 * @property {string} user_type - user_type
 * @property {string} mode - {Desktop/Mobile/Tablet}
 * @property {GUID} msid - msid
 * @return {LogObject<getFeedbackChangePixelsHeaderParams>} LogObject<getFeedbackChangePixelsHeaderParams>
 */
export function getFeedbackChangePixelsHeader(params) {
    return { evid: 1129, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackAddPersonToList' event (evid: 1123)
 *
 * Event description: Fires when user adds someone to the list
 *
 * @param {getFeedbackAddPersonToListParams} params - The parameters for this event
 * @property {boolean} contactOrNot - true if person added is contact
 * @property {GUID} msid - msid
 * @property {string} origin - source name
 * @return {LogObject<getFeedbackAddPersonToListParams>} LogObject<getFeedbackAddPersonToListParams>
 */
export function getFeedbackAddPersonToList(params) {
    return { evid: 1123, src: 80, endpoint: 'get-feedback', params: params };
}
/**
 * A function to create a log object for the 'getFeedbackSiteSelectorDialogClosed' event (evid: 1118)
 *
 * Event description: clicked to close site selector get feedback dialog
 *
 * @param {getFeedbackSiteSelectorDialogClosedParams} params - The parameters for this event
 * @return {LogObject<getFeedbackSiteSelectorDialogClosedParams>} LogObject<getFeedbackSiteSelectorDialogClosedParams>
 */
export function getFeedbackSiteSelectorDialogClosed(params) {
    return { evid: 1118, src: 80, endpoint: 'get-feedback', params: params };
}
//# sourceMappingURL=index.js.map